import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { GetFormaEnvioListResponse } from '../../responses/vendas/get-forma-envio-list.response';
import { GetFormaEnvioResponse } from '../../responses/vendas/get-forma-envio.response';
import { FormaEnvioLookupsResponse } from '../../responses/vendas/forma-envio-lookups.response';
import { BuscarServicosLogisticaResponse } from '../../responses/vendas/buscar-servicos-logistica.response';
import { FormaEnvioSalvarRequest } from '../../requests/vendas/forma-envio.request';
import { BuscarServicosLogisticaRequest } from '../../requests/vendas/buscar-servicos-logistica.request';

@Injectable({
    providedIn: 'root',
})
export class FormaEnvioService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'FormaEnvio';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getList(
        descricao?: string,
        idTipoLogistica?: number,
        isAtivo?: boolean,
        pagina: number = 0,
        tamanhoPagina: number = 20,
    ): Observable<GetFormaEnvioListResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) params = params.set('descricao', descricao);
        if (idTipoLogistica != null) params = params.set('idTipoLogistica', idTipoLogistica.toString());
        if (isAtivo != null) params = params.set('isAtivo', isAtivo.toString());

        return this.httpClient
            .get<GetFormaEnvioListResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<GetFormaEnvioResponse> {
        return this.httpClient
            .get<GetFormaEnvioResponse>(`${this.apiUrl}/${id}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookups(): Observable<FormaEnvioLookupsResponse> {
        return this.httpClient
            .get<FormaEnvioLookupsResponse>(`${this.apiUrl}/lookups`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public incluir(request: FormaEnvioSalvarRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public alterar(id: number, request: FormaEnvioSalvarRequest): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(`${this.apiUrl}/${id}`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public toggleAtivo(id: number, isAtivo: boolean): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(`${this.apiUrl}/${id}/ativo`, { isAtivo }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public excluirBulk(idsFormaEnvio: number[]): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(`${this.apiUrl}/excluir-bulk`, { idsFormaEnvio }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public buscarServicos(request: BuscarServicosLogisticaRequest): Observable<BuscarServicosLogisticaResponse> {
        return this.httpClient
            .post<BuscarServicosLogisticaResponse>(`${this.apiUrl}/buscar-servicos`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
